import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SearchableField } from 'common/form/SearchableField';
import { useInvoiceInsuranceMemberIdOptions } from '../../hooks';

export const InsuranceMemberIdFilter = ({
  className,
  invoicesQuery,
  onChange,
  value,
}) => {
  const [insuranceMemberIdSearchQuery, setInsuranceMemberIdSearchQuery] = useState(value);

  useEffect(() => {
    setInsuranceMemberIdSearchQuery(value);
  }, [value]);

  const insuranceMemberIdOptions = useInvoiceInsuranceMemberIdOptions(insuranceMemberIdSearchQuery, invoicesQuery);

  return (
    <SearchableField
      className={className}
      label="Insurance Member ID"
      labelClassName="tracking-normal"
      onChange={({ value: val }) => onChange(val)}
      searchQuery={insuranceMemberIdSearchQuery}
      options={insuranceMemberIdOptions}
      onInputChange={setInsuranceMemberIdSearchQuery}
      placeholder="Search by Insurance Member ID"
      truncateOptions={false}
      clearable
    />
  );
};

InsuranceMemberIdFilter.propTypes = {
  className: PropTypes.string,
  invoicesQuery: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};
InsuranceMemberIdFilter.defaultProps = {
  className: undefined,
  value: undefined,
};
